import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, useQuery, UseQueryOptions } from 'react-query';
import client from '@/utils/httpClient';

export const patientIdentifierKeys = {
  base: () => ['patientIdentifier'],
  get: (patientId: string, identifierKey: string) => [
    ...patientIdentifierKeys.base(),
    patientId,
    identifierKey
  ]
};

interface PatientIdentifierDto {
	id: string;
	idType: string;
	idValue: string;
}

function addPatientIdentifier(patientId: string, idType: string, idValue: string) {
  return client.put(`/api/patients/${patientId}/addPatientIdentifier`, {
    idType,
    idValue
  });
}

interface AddPatientIdentifierParameters {
	patientId: string;
	idType: string;
	idValue: string;
}

export function useAddPatientIdentifier(
  options?: UseMutationOptions<any, AxiosError, AddPatientIdentifierParameters>
) {
  return useMutation(
    async ({ patientId, idType, idValue }) => addPatientIdentifier(patientId, idType, idValue),
    options
  );
}

function removePatientIdentifier(patientId: string, value: string) {
  return client.put(`/api/patients/${patientId}/removePatientIdentifier/${value}`);
}

interface RemovePatientIdentifierParameters {
	patientId: string;
	value: string;
}

export function useRemovePatientIdentifier(
  options?: UseMutationOptions<any, AxiosError, RemovePatientIdentifierParameters>
) {
  return useMutation(
    async ({ patientId, value }) => removePatientIdentifier(patientId, value),
    options
  );
}

function getPatientIdentifier(patientId: string, identifierKey: string) {
  return client
    .get(`/api/patients/${patientId}/patientIdentifier/${identifierKey}`)
    .then((response) => response.data as PatientIdentifierDto);
}

export function usePatientIdentifier(
  patientId: string,
  identifierKey: string,
  options?: UseQueryOptions<PatientIdentifierDto>
) {
  return useQuery(
    patientIdentifierKeys.get(patientId, identifierKey),
    () => getPatientIdentifier(patientId, identifierKey),
    options
  );
}
